// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SectionSlab,
    SectionSlabFromJSON,
    SectionSlabToJSON,
} from '../models';

export interface SlabsReadRequest {
    id: string;
}

/**
 * no description
 */
export class SectionSlabsApi extends runtime.BaseAPI {

    /**
     * Return section slabs with items
     */
    async slabsReadRaw(requestParameters: SlabsReadRequest): Promise<runtime.ApiResponse<SectionSlab>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling slabsRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("LabXChange API", ["read", "write"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/section_slabs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionSlabFromJSON(jsonValue));
    }

    /**
     * Return section slabs with items
     */
    async slabsRead(requestParameters: SlabsReadRequest): Promise<SectionSlab> {
        const response = await this.slabsReadRaw(requestParameters);
        return await response.value();
    }

}
